angular.module('dpw.services').factory('trackUtil', ['user', function (user) {

    var trackerProviders = [{
        name: 'GoogleAnalytics',
        enabled: RCDPW.GoogleAnalytics.enabled,
        id: RCDPW.GoogleAnalytics.TrackingID
    }, {
        name: 'TwitterTracking',
        preCondition: (RCDPW.pageName === 'Home'),
        enabled: RCDPW.TwitterTracking.Enabled,
        id: RCDPW.TwitterTracking.Pid
    }];

    function trackPage(pageName, path) {
        angular.forEach(trackerProviders, function (tracker) {
            isEnabled(tracker) && doTracking(tracker);
        });

        function isEnabled(tracker) {
            if (RCDPW.isAdminSite || tracker.preCondition === false) {
                return false;
            }
            var cookie = $.cookie(tracker.name);
            if (cookie != null) {
                tracker.enabled = (cookie === '1');
            }
            return tracker.enabled;
        }

        function doTracking(tracker) {
            if (!tracker.trackerInstance) {
                tracker.trackerInstance = new window[tracker.name](tracker.id);
            }
            if (!RCDPW.isLogin) {
                tracker.trackerInstance.logPageView(pageName, null, path);
            } else {
                user.fetch().then(function () {
                    var userObj = user.getUser();
                    tracker.trackerInstance.logPageView(pageName, userObj.accountId, path);
                });
            }
        }
    }

    RCDPW.enableTrack = function (enable) {
        enable = (enable !== false);
        angular.forEach(trackerProviders, function (tracker) {
            $.cookie(tracker.name, enable ? 1 : 0);
        });
    };

    return {
        logPageView: function (pageName, path) {
            if ($.trim(pageName) !== "") {
                $.cookie('showTrackLog') && RCDPW.console.log('Track:', pageName);
                trackPage(pageName, path);
            }
        }
    };
}]);

RCDPW.GoogleAnalytics = {enabled: false, TrackingID: 'G-M8DPDH4RSF'};
RCDPW.TwitterTracking = {Enabled: false, Pid: 'l5krl'};
/**
 ADS(dpw.xml) will append RCDPW.GoogleAnalytics configuration statement
 **/
